import { useMutation, useQueryClient } from 'react-query';
import updateDeal from '../workflows/updateDeal';

export default function useDealUpdate() {
  const queryClient = useQueryClient();

  return useMutation(updateDeal, {
    onSuccess: async (response) => {
      if (!response || response.isBadRequest) {
        return;
      }

      queryClient.invalidateQueries(['deal.getById', response.id]);

      await Promise.all(response.client_ids.map((clientId) =>
        queryClient.invalidateQueries(['deal.getByClientId', clientId]),
      ));

      if (response.updatedTemplateIds?.length) {
        await Promise.all(response.updatedTemplateIds.map((templateId) =>
          queryClient.invalidateQueries(['template.getById', templateId]),
        ));
      }
    },
  });
}
